import type { paths } from "./types.gen";
import { apiFetch } from "./client";

type LoginResponse = paths["/api/auth/login"]["post"]["responses"]["200"]["content"]["application/json"];
type VerifyResponse = paths["/api/auth/verify"]["get"]["responses"]["200"]["content"]["application/json"];
type MeResponse = paths["/api/auth/me"]["get"]["responses"]["200"]["content"]["application/json"];
type LogoutResponse = paths["/api/auth/logout"]["post"]["responses"]["200"]["content"]["application/json"];
type SsoConfigResponse = paths["/api/auth/sso/config"]["get"]["responses"]["200"]["content"]["application/json"];

export const authApi = {

    login(email: string): Promise<LoginResponse> {

        return apiFetch<LoginResponse>("/api/auth/login", { method: "POST", json: { email } });
    },

    verify(token: string): Promise<VerifyResponse> {

        // the verify page renders its own inline error (e.g. "Invalid or expired
        // token") on a 401, so it must not be bounced to /login by the global
        // unauthorized handler.
        return apiFetch<VerifyResponse>(`/api/auth/verify?token=${encodeURIComponent(token)}`, { method: "GET", skipAuthRedirect: true });
    },

    me(options?: { skipAuthRedirect?: boolean }): Promise<MeResponse> {

        return apiFetch<MeResponse>("/api/auth/me", { method: "GET", skipAuthRedirect: options?.skipAuthRedirect });
    },

    logout(): Promise<LogoutResponse> {

        return apiFetch<LogoutResponse>("/api/auth/logout", { method: "POST" });
    },

    ssoConfig(): Promise<SsoConfigResponse> {

        // the login screen is unauthenticated, so a 401 here must not bounce
        // the user into a redirect loop.
        return apiFetch<SsoConfigResponse>("/api/auth/sso/config", { method: "GET", skipAuthRedirect: true });
    },
};
